// extracted by mini-css-extract-plugin
export var active = "WasteContent-module--active--dhopJ";
export var content = "WasteContent-module--content--JNU94";
export var tabButton = "WasteContent-module--tabButton--xdvLo";
export var tabs = "WasteContent-module--tabs--4HkJR";
export var total = "WasteContent-module--total--0nCOv";
export var wasteTable = "WasteContent-module--wasteTable--rqm3U";